// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3dtOr","label":"Category_label__1NDFc","content":"Category_content__-Iu3u","header":"Category_header__8eSub","location":"Category_location__jjFZ_"};